module.exports = __webpack_public_path__ + "bd056f90fd65abe3b358004cc7a4f36e.pdf";